module.exports = __webpack_public_path__ + "img/事業内容@3x.52b65bf8.png";